import { Component, OnInit, Input } from '@angular/core';
import {Router} from '@angular/router';
import {enumValue} from '../../../../constant.enum';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  enumValue = enumValue;
  @Input() pageTitle: string;
  public additionalLinks: { name: string; url: string; type?: string; arialabel?: string }[] = [];
 
  constructor(private route: Router) { }
 
  ngOnInit() {
    const  originUrl = encodeURI( window.location.origin + '/contactUs');
 
    // huk-footer additionalLinks supplied by this component: Contact Us, Your California Privacy Choices, and Feedback.
    // Include the California Privacy Choices link here so the CA privacy icon is rendered.
    this.additionalLinks = [
      {
        name: 'Contact Us',
        url: originUrl,
        type: 'default',
        arialabel: 'Contact Us'
      },
     {
        name: 'Your California Privacy Choices',
        url: 'https://www.thehartford.com/data-privacy-opt-out-form',
        type: 'CA',
        arialabel: 'Your California Privacy Choices'
      },
      {
        name: 'Feedback',
        url: 'https://nebula-cdn.kampyle.com/direct/form.html?region=prodUsOregon&websiteId=283143&formId=14007',
        type: 'default',
        arialabel: 'Feedback'
      }
    ];
  }
 
 
}